var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("基地管理")]),
              _c("el-breadcrumb-item", [_vm._v("基地数据统计")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "hx-form-container box-shadow" },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.listParams,
                "label-width": "100px",
                inline: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "领货时间：", prop: "timeInterval" } },
                [
                  _c("date-picker-group", {
                    model: {
                      value: _vm.listParams.timeInterval,
                      callback: function ($$v) {
                        _vm.$set(_vm.listParams, "timeInterval", $$v)
                      },
                      expression: "listParams.timeInterval",
                    },
                  }),
                ],
                1
              ),
              !_vm.baseId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "选择基地：", prop: "farmId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            size: "small",
                            placeholder: "请选择基地",
                          },
                          model: {
                            value: _vm.listParams.farmId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listParams, "farmId", $$v)
                            },
                            expression: "listParams.farmId",
                          },
                        },
                        _vm._l(_vm.baseNameList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.title, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.loadTableData },
                    },
                    [_vm._v(" 查询 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: {
            "page-info": _vm.pager,
            loading: _vm.tableLoading,
            showPagerOnOnePage: false,
          },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              {
                staticClass: "wrap-table-info-display",
                staticStyle: { height: "32px" },
              },
              [
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "farmTitle",
                  align: "center",
                  label: "基地名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "菜品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodTitle))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "菜品单价(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodOnSelfPrice))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "", align: "center", label: "保障单价(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodPrice))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodWeight",
                  align: "center",
                  label: "菜品重量(g)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodWeight))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodCount",
                  align: "center",
                  label: "菜品数量(份)",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.goodCount))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  width: "350px",
                  prop: "supplypTime",
                  align: "center",
                  label: "领货时间",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.supplypTime))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "total", align: "center", label: "合计(元)" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.farmProdutionDataList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "line-height-style" },
                            [_c("span", [_vm._v(_vm._s(item.total))])]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }